import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 16px;
  line-height: 140%;
  font-weight: ${props => props.theme.fontWeightBold};
  color: #8EA3B5;
  margin: 24px 0;

  em {
    color: ${props => props.theme.bodyColor};
    font-style: normal;
    font-weight: ${props => props.theme.fontWeightHeavy};
  }
`;

const wireLabel = count => (count === 1 ? 'wire' : 'wires');

export default function Stats({
  type, total, contributorName, mentionsTotal,
}) {
  return (
    <Container>
      We found&nbsp;
      <em>{total - mentionsTotal}</em>
      &nbsp;
      {type === 'all' && (
        <>
          {`${wireLabel(total - mentionsTotal)} published by and `}
          <em>{mentionsTotal}</em>
          {` ${wireLabel(mentionsTotal)} that mention `}
        </>
      )}
      {type === 'latest' && `${wireLabel(total)} published by `}
      {type === 'mentions' && `${wireLabel(total)} mention `}
      <em>{contributorName}</em>
    </Container>
  );
}

Stats.propTypes = {
  contributorName: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['all', 'latest', 'mentions']).isRequired,
  total: PropTypes.number.isRequired,
  mentionsTotal: PropTypes.number,
};

Stats.defaultProps = { mentionsTotal: 0 };
